<!--
 * @Description: 
 * @Date: 2022-04-20 17:25:59
-->
<template>
  <div class="project-list">
    <!--    {{user}}-->
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'project-list',
  props: {
    container: {
      type: String
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  provide() {
    return {
      isMaster: this.userInfo && +this.userInfo['isMainAccountNumber'] === 1,
      container: this.container
    };
  }
};
</script>

<style scoped lang="scss">
.project-list {
  transform: translate3d(0, 0, 0);
  width: 97vw;
  // padding: 10px;
  @media screen and (max-width: 3000px) {
    //padding-top: 19%;
  }
  @media screen and (max-width: 1900px) {
    min-width: 1200px;
    //padding-top: 21%;
    //width: 1200px;
  }
}
</style>
